<template>
  <div class="my-org">
    <div class="step1">
      <div class="org-detail">
        <Entdetail v-if="status==0" :dataEnt="dataEnt"></Entdetail>
        <Govdetail v-if="status==1" :dataGov="dataGov"></Govdetail>
      </div>
    </div>
  </div>
</template>
<script>
import Entdetail from '../../components/plan/Entdetail.vue'
import Govdetail from '../../components/plan/Govdetail.vue'
import company from '../../data/basic/plan/company.js'
import weather from '../../data/emer/weather.js'
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      // 显示权限
      status: 0,
      dataEnt: {},
      dataGov: {},
      list: []
    }
  },
  created() {
    this.list = JSON.parse(sessionStorage.itemName)
    // 执行状态控制方法
    this.status = this.list.type
    this.getOrgDetail()

  },
  methods: {
    // returnbank() {
    //   this.$router.push('/home')
    // },
    // // 点击
    // confirm() {
    //   this.$router.push('/Steptwo')
    // },
    // 获取申报单位详情
    getOrgDetail() {
      // switch (JSON.parse(this.list.type)) {
      //   case 0:
      //     this.start_process({
      //       processKey: HeavyPollWeather,
      //       subjectId: this.list.id
      //     })
      //     break;
      //   case 1:
      //     this.start_process({
      //       processKey: HeavyPollWeather,
      //       subjectId: this.list.id
      //     })
      //     break;
      // }
      this.start_process({
        processKey: HeavyPollWeather,
        subjectId: this.list.id
      })
    },

//  流程标识
    start_process(params) {
      (async() => {
        let getState = await weather.process_start(params)
        if (getState.status) {
          this.dataGov = getState.data
          this.$message.success('成功')
        } else {
          this.$message.error(getState.msg)
        }
      })
    }
  },
  components: {
    Entdetail,
    Govdetail
  }
}

</script>
<style lang="stylus" scoped>
.step-box {
  text-align: center;
  margin-top: 30px;
}

.step1 {
  margin-top: 20px;
  width: 450px;
  min-width: 450px; // margin: 30px auto;
  // margin-left:150px
  text-align: left;
  .org-control {
    // width: 200px;
    // margin: 0 auto;
    margin-left: 155px;
  }
}

.org-control {}

</style>



// WEBPACK FOOTER //
// confirmInfo.vue?eb554fb6